import React from 'react';
import { dataModelerHandleRemoveDraftTableData } from '../../../../redux/slices/dataModeler';
import {
  ActionIcon,
  CenteredDiv,
  ClickableStyledFormUIRow,
  dataModelerTablesEditorGridColumns,
  EmptyDiv,
  IconsRowDiv,
} from '../DataModelerCommonUI';
import KubitTooltip from '../../../../components/KubitTooltip';
import { dataModelTooltipOptions } from '../../../../components/KubitTooltip/globalTooltips';
import { useAppDispatch } from '../../../../redux/hooks';
import GeneralFormItem from '../../../../components/GeneralFormItem';
import { ISortableTableItem } from './types';
import { ModifiedIcon } from '../DataModelerShared';

interface IProps {
  schemaKey: string;
  tableItem: ISortableTableItem;
  expandTable: (tableKey: string) => void;
}

const DataModelerTableRow = ({ tableItem, schemaKey, expandTable }: IProps) => {
  const dispatch = useAppDispatch();
  const {
    tableKey,
    isNew,
    isModified,
    isFactTable,
    sqlTableName,
    canRemove,
    // joinCondition,
  } = tableItem;

  const toggleExpanded = () => {
    expandTable(tableKey);
  };

  const handleRemoveTableClick = (tableKey: string) => {
    dispatch(dataModelerHandleRemoveDraftTableData({ tableKey }));
  };

  // XXX strip the schema key from the displayed table key
  const displayedTableKey = tableKey
    .toLowerCase()
    .startsWith(`${schemaKey.toLowerCase()}.`)
    ? tableKey.substring(schemaKey.length + 1)
    : tableKey;

  return (
    <>
      <ClickableStyledFormUIRow
        $gridTemplateColumns={dataModelerTablesEditorGridColumns}
      >
        <div onClick={toggleExpanded}>{isFactTable ? 'Fact' : 'Dimension'}</div>
        <GeneralFormItem
          key={'tableKey'}
          label={displayedTableKey.toUpperCase()}
          isDisabled={false}
          isBold={true}
          onClick={toggleExpanded}
        />
        <GeneralFormItem
          key={'tableName'}
          label={sqlTableName.toUpperCase()}
          isDisabled={false}
          isBold={true}
          onClick={toggleExpanded}
        />
        {canRemove ? (
          <CenteredDiv>
            <KubitTooltip
              placement="top-start"
              {...dataModelTooltipOptions.addedTableIcon}
              noOpenDelay={true}
            >
              <div onClick={() => handleRemoveTableClick(tableKey)}>
                <ActionIcon name="icon-x" width={8} height={8} />
              </div>
            </KubitTooltip>
          </CenteredDiv>
        ) : isNew || isModified ? (
          <KubitTooltip
            {...(isNew
              ? dataModelTooltipOptions.addedTableNonRemovableIcon
              : dataModelTooltipOptions.modifiedTableIcon)}
            placement="top-start"
            noOpenDelay={true}
          >
            <IconsRowDiv onClick={toggleExpanded}>
              <ModifiedIcon isClickable={true} />
            </IconsRowDiv>
          </KubitTooltip>
        ) : (
          <EmptyDiv onClick={toggleExpanded} />
        )}
      </ClickableStyledFormUIRow>
    </>
  );
};

export default DataModelerTableRow;
